import React, { useRef, useState } from "react";
import { toPng } from "html-to-image";
import { toast } from "sonner";
import { Download, Share2, Heart, Camera } from "lucide-react";
import Modal from "../Modal";

// Kartu "Foto Bareng Mochi": snapshot kanvas 3D + identitas pasangan, siap unduh/bagikan.
export default function MochiPhotoModal({ open, onClose, shot, coupleName, level, moodLabel, accessoryLabel, bg }) {
  const cardRef = useRef();
  const [busy, setBusy] = useState(false);
  const dateLabel = new Date().toLocaleDateString("id-ID", { day: "numeric", month: "long", year: "numeric" });
  const filename = `mochi-${(coupleName || "kita").toLowerCase().replace(/\s+/g, "-")}.png`;

  const genBlob = async () => {
    let dataUrl;
    try { dataUrl = await toPng(cardRef.current, { pixelRatio: 2, cacheBust: true }); }
    catch { dataUrl = await toPng(cardRef.current, { pixelRatio: 2, cacheBust: true, skipFonts: true }); }
    return await (await fetch(dataUrl)).blob();
  };
  const download = async () => {
    setBusy(true);
    try {
      const url = URL.createObjectURL(await genBlob());
      const a = document.createElement("a"); a.download = filename; a.href = url; a.click();
      URL.revokeObjectURL(url);
      toast.success("Foto Mochi diunduh 📸");
    } catch { toast.error("Gagal membuat foto. Coba lagi."); }
    finally { setBusy(false); }
  };
  const share = async () => {
    setBusy(true);
    try {
      const blob = await genBlob();
      const file = new File([blob], filename, { type: "image/png" });
      const text = `Foto bareng Mochi, peliharaan ${coupleName} 🐱💕 #KencanKita`;
      if (navigator.canShare && navigator.canShare({ files: [file] })) { await navigator.share({ files: [file], text, title: "Foto Bareng Mochi" }); return; }
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a"); a.download = filename; a.href = url; a.click();
      URL.revokeObjectURL(url);
      window.open(`https://wa.me/?text=${encodeURIComponent(text)}`, "_blank");
      toast.success("Foto diunduh — lampirkan ke WhatsApp 💬");
    } catch { toast.error("Gagal membagikan. Coba lagi."); }
    finally { setBusy(false); }
  };

  return (
    <Modal open={open} onClose={onClose} title="Foto bareng Mochi" testId="mochi-photo-modal">
      <div className="flex flex-col items-center gap-4 p-5">
        <div ref={cardRef} data-testid="mochi-photo-card"
          style={{ width: 340, background: "#fff", fontFamily: "'Plus Jakarta Sans', sans-serif" }}
          className="overflow-hidden rounded-[26px] shadow-md">
          <div className="relative" style={{ height: 380, background: bg }}>
            {shot && <img src={shot} alt="Mochi" style={{ position: "absolute", inset: 0, width: "100%", height: "100%", objectFit: "cover" }} />}
            <div className="absolute left-4 top-4 flex items-center gap-1.5 rounded-full px-3 py-1.5" style={{ background: "rgba(255,255,255,0.92)" }}>
              <Heart className="h-3.5 w-3.5" style={{ color: "#ff5a5f", fill: "#ff5a5f" }} />
              <span style={{ color: "#c9566b", fontSize: 12, fontWeight: 800 }}>{coupleName}</span>
            </div>
            <div className="absolute right-4 top-4 rounded-full px-3 py-1.5" style={{ background: "linear-gradient(135deg,#ff6b4a,#ff5a5f)" }}>
              <span style={{ color: "#fff", fontSize: 12, fontWeight: 900 }}>KencanKita</span>
            </div>
            <div className="absolute inset-x-0 bottom-0 p-4" style={{ background: "linear-gradient(to top, rgba(0,0,0,0.55), rgba(0,0,0,0))", color: "#fff" }}>
              <div style={{ fontSize: 22, fontWeight: 900, lineHeight: 1.1 }}>Mochi · Level {level}</div>
              <div style={{ fontSize: 13, opacity: 0.92, marginTop: 2 }}>Lagi {String(moodLabel || "").toLowerCase()} {accessoryLabel ? `· pakai ${accessoryLabel}` : ""}</div>
            </div>
          </div>
          <div className="flex items-center justify-between px-5 py-4">
            <span style={{ color: "#8a8278", fontSize: 12, fontWeight: 700 }}>{dateLabel}</span>
            <span style={{ color: "#c9a86a", fontSize: 11, fontWeight: 800 }}>#KencanKita 🐱💕</span>
          </div>
        </div>
        <div className="flex w-full max-w-[340px] gap-2">
          <button onClick={download} disabled={busy} data-testid="photo-download"
            className="flex flex-1 items-center justify-center gap-2 rounded-full kk-coral-gradient py-3 text-[14px] font-bold text-white disabled:opacity-60">
            <Download className="h-4 w-4" /> Unduh
          </button>
          <button onClick={share} disabled={busy} data-testid="photo-share"
            className="flex flex-1 items-center justify-center gap-2 rounded-full border border-[#eee5da] bg-[#f9f5f0] py-3 text-[14px] font-bold text-[#6e594c] disabled:opacity-60">
            <Share2 className="h-4 w-4" /> Bagikan
          </button>
        </div>
        <p className="flex items-center gap-1 text-[11px] text-[#a69995]"><Camera className="h-3 w-3" /> Foto diambil dari panggung 3D lengkap dengan aksesori yang dipakai.</p>
      </div>
    </Modal>
  );
}
